import React from 'react';

const ModuleHeader = ({ children }) => {
  return (
    <div className="ModuleHeader">
      <h2>{children}</h2>
    </div>
  );
};

export default ModuleHeader;
